interface AuthRoute {
    CONNECT: string;
}

export const authRoute: AuthRoute = {
    CONNECT: '/connect',
};
